import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import styles from './ReviewedReminder.module.scss';

function ReviewedReminder({icon, text}) {
  return (
    <b className={styles.container}>
      <FontAwesomeIcon icon={icon} size="1x" color="white" />
      {text}
    </b>
  );
}

export default ReviewedReminder;
